var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-list-short" },
    [
      _vm.loading
        ? [
            _c("Loading", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                Loading your data…\n            "
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2276262908
              )
            })
          ]
        : _vm._l(_vm.products, function(product) {
            return _c("div", { staticClass: "product-list-short__item" }, [
              _c("div", { staticClass: "product-list-short__item-inside" }, [
                product.icon
                  ? _c("div", {
                      staticClass: "product-list-short__item-visual",
                      domProps: {
                        innerHTML: _vm._s(
                          "<i data-icon='&#x" + product.icon + ";'></i>"
                        )
                      }
                    })
                  : product.image
                  ? _c(
                      "div",
                      { staticClass: "product-list-short__item-visual" },
                      [
                        _c("img", {
                          attrs: {
                            src: product.image.src,
                            alt: product.image.alt,
                            width: product.image.width,
                            height: product.image.height,
                            title: product.image.title
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "product-list-short__item-content" }, [
                  _c("h2", { staticClass: "product-list-short__item-name" }, [
                    _vm._v(_vm._s(product.name))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "product-list-short__item-price product-price product-price--lg"
                    },
                    [
                      _c("div", { staticClass: "product-price__value" }, [
                        _vm._v(_vm._s(product.price))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "product-price__text" }, [
                        _vm._v("(VAT incl.)")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "product-list-short__item-buttons" }, [
                  _c(
                    "div",
                    { staticClass: "buttons-group-sm buttons-group--no-wrap" },
                    [
                      product.teaser
                        ? _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    placement:
                                      _vm.$mq === "xs" ? "bottom" : "left-start"
                                  },
                                  expression:
                                    "{ placement : $mq === 'xs' ? 'bottom'  : 'left-start' }"
                                }
                              ],
                              staticClass:
                                "btn btn-secondary btn-one-icon rounded-circle",
                              attrs: { content: product.teaser }
                            },
                            [_c("i", { staticClass: "icon icon-info" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { placement: "top" },
                              expression: "{ placement : 'top' }"
                            }
                          ],
                          staticClass:
                            "btn btn-primary btn-one-icon rounded-circle",
                          attrs: {
                            content: product.inCart
                              ? "Remove from Cart"
                              : "Add to Cart",
                            disabled: _vm.loadingProductId
                          },
                          on: {
                            click: function($event) {
                              product.inCart
                                ? _vm.onProductRemove(product)
                                : _vm.onProductAdd(product)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "icon",
                            class:
                              _vm.loadingProductId === product.id
                                ? "spinner-border spinner-border-sm"
                                : product.inCart
                                ? "icon-x"
                                : "icon-shopping-bag"
                          })
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }